import React, { useState } from 'react'
import { View } from 'react-native'
import PropTypes from 'prop-types'
import Modal from 'react-native-modal'

import { VFText } from '@vfgroup-oneplatform/foundation/Components'
import { Colors, withTheme } from '@vfgroup-oneplatform/foundation/Components/Themes'

import Collapsible from '../Collapsible'
import OfferDescription from '../OfferDescription'
import OfferContent from '../OfferContent'
import OrderComplete from '../ModalContent'

import { Images, getThemeImages } from '../../Themes'

import styles from './Offer.Styles'

const Offer = ({
  selectedOffer,
  setSelectedOffer,
  currentIndex,
  changeCurrentIndex,
  offers,
  offersLoading,
  offerError,
  onClose,
  theme
}) => {

  const offersArray = offersLoading ? [{}, {}, {}] : offers

  const themedImages = getThemeImages(theme.name)

  const [buttonLoading, setButtonLoading] = useState(false)

  const selectOffer = (data) => {
    setSelectedOffer(data)
    changeCurrentIndex(currentIndex + 1)
  }

  return (
    <View style={styles.container}>
      <View>
        <VFText
          i18nKey="acquisition_offer_step_title"
          style={styles.stepTitle}
        />
        <VFText
          i18nKey="acquisition_offer_step_subtitle"
          style={styles.stepDescription(theme)}
        />
        <Collapsible
          items={offersArray.map((offer, index) => ({
            icon: themedImages.bundle || offer?.icon,
            title: offer.title || '',
            desc: () => (
              <OfferDescription
                price={offer?.price || ''}
                period={offer?.isMonthly ? 'acquisition_monthly' : ''}
                priceReduction={offer?.priceReduction || ''}
              />
            ),
            content: <OfferContent
              offer={offer}
              buttonLoading={buttonLoading}
              selectOffer={selectOffer}
            />,
            isOpend: true,
            isLoading: offersLoading,
            card: {
              shadowLevel: 'low',
              title: offer?.recomandation_type ? 'acquisition_recommended_offer' : undefined,
            },
            style: {
              borderWidth: index === selectedOffer ? 1 : 0,
              borderColor: Colors.blue_two,
              borderRadius: 7,
              borderTopLeftRadius: offer.recomandation_type ? 0 : 7,
            },
          }))}
          titleStyle={styles.titleOfferStyle}
          // selected={}
          setSelected={() => { }}
          withCard
          cardStyle={styles.offerCardStyle}
        />
      </View>
      <Modal isVisible={Boolean(offerError)} style={styles.modal} >
        <View style={styles.modalContentContainer(theme)} >
          <OrderComplete
            onClose={onClose}
            error={offerError}
            errorMessage={offerError}
            buttonTitle="acquisition_go_back"
            onButtonPress={onClose}
          />
        </View>
      </Modal>
    </View>
  )
}


Offer.propTypes = {
  selectedOffer: PropTypes.number,
  setSelectedOffer: PropTypes.func,
  currentIndex: PropTypes.number,
  changeCurrentIndex: PropTypes.func,
  changeActiveStep: PropTypes.func,
  offers: PropTypes.array,
  offersLoading: PropTypes.bool,
  offerError: PropTypes.string,
  onClose: PropTypes.func,
  theme: PropTypes.object,
}

export default withTheme(Offer)
